import { translate } from "utils";
import { MERCHANT_REQUEST_STATUS } from "./type";

export const merchantRequestType = [
	{
		label: "Car",
		value: "car",
	},
	{
		label: "Service",
		value: "service",
	},
];

export const merchantRequestStatus = [
	{
		label: "Wait list",
		value: MERCHANT_REQUEST_STATUS.WAIT_LIST,
		color: "#4096ff",
	},
	{
		label: "Processing",
		value: MERCHANT_REQUEST_STATUS.PROCESSING,
		color: "#ffa940",
	},
	{
		label: "Completed",
		value: MERCHANT_REQUEST_STATUS.COMPLETED,
		color: "#73d13d",
	},
	{
		label: "Removed",
		value: MERCHANT_REQUEST_STATUS.REMOVED,
		color: "#f5222d",
	},
];
